// Block labels/colors for the Day Board theme — ported from school-site's
// BlockCard.tsx. Only meaningful inside .day-board-theme (StudentView and
// its children), where these CSS custom properties are defined.
export const BLOCK_LABEL = {
  launch: 'Launch',
  math: 'Math',
  la: 'Language arts',
  logic: 'Logic',
  history: 'History',
  afternoon: 'Afternoon',
  fixed: 'Fixed commitment',
  calendar: 'On the calendar',
};

export const BLOCK_COLOR = {
  launch: 'var(--c-launch)',
  math: 'var(--c-math)',
  la: 'var(--c-la)',
  logic: 'var(--c-logic)',
  history: 'var(--c-history)',
  afternoon: 'var(--c-afternoon)',
  fixed: 'var(--ink-3)',
  calendar: 'var(--c-calendar)',
};
